import React from 'react';

import ResetPassword from 'client/components/ResetPassword/ResetPassword';
import {useResetOwnPasswordMutation} from '../ResetPassword/ResetPassword.queries.generated';

interface ChangePasswordProps {
  legend?: string;
  userId: string;
  [key: string]: any;
}

/**
 * ChangePassword
 * ==============
 *
 * The ChangePassword component appears in:
 *   1) the Account Settings page (PasswordAndSettings.tsx)
 *   2) the landing page for users whose token requires them to
 *      update their password (ChangePasswordLandingPage.tsx)
 *
 * It returns an instance of a ResetPassword component with the
 * handlers needed to submit a new password. A successful login is
 * sufficient evidence of authorization, so no current password is
 * required.
 */
const ChangePassword = ({legend, userId, ...rest}: ChangePasswordProps) => {
  const [resetOwnPasswordMutation] = useResetOwnPasswordMutation();

  const handleSubmit = async (password: string) => {
    const {data} = await resetOwnPasswordMutation({
      variables: {
        input: {newPassword: password}
      }
    });

    const result = data?.resetOwnPassword;
    if (result?.error) {
      throw result.error;
    }
  };

  return (
    <ResetPassword onSubmit={handleSubmit} {...rest}>
      {legend && <ResetPassword.Legend>{legend}</ResetPassword.Legend>}
      <ResetPassword.Form>
        <ResetPassword.NewPasswordField />
        <ResetPassword.ConfirmPasswordField />
        <ResetPassword.ShowPasswordToggle />
      </ResetPassword.Form>
    </ResetPassword>
  );
};

export default ChangePassword;
